export default {
  forgot_password: {
    title: '重置密码',
    required: '@:validation.required',
    incorrect_email_address: '@:validation.email_format',
    double_check_text: '@:login.double_check_text',
    forgot_password: '如忘记密码',
    password_reset_text: '请输入电子邮件地址并点击发送按钮，您将收到一封进行重置密码操作的电子邮件。',
    submit: '发送',
    mail_address: '请输入电子邮件地址',
    input_label: '@:settings.user.email',
  },
}
